import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { XIcon, PlusIcon } from "@heroicons/react/solid";

import MediaSelectModal from "Components/MediaSelectModal";

const classes = {
    closeButton: "invisible group-hover:visible absolute right-0 top-0 p-0.5 border-white border-2 bg-gray-600 items-center justify-center rounded-full text-white hover:bg-black transition ease-in-out duration-150"
};

/**
 * @todo add a limit property which, when reached, hides add button..
 */
export default class AttachedImages extends React.Component
{
    state = {
        selectDialog: false,
    };

    static propTypes = {
        media: PropTypes.array.isRequired,
        limit: PropTypes.number,

        onAdd: PropTypes.func.isRequired,
        onRemove: PropTypes.func.isRequired,
    };

    static defaultProps = {
        limit: 0
    };

    render()
    {
        const {media, limit} = this.props;

        return <>
            <div className='grid inline-grid gap-4 grid-cols-6'>
                {
                    media.map((media, index) => {
                        return <Image key={index} id={media.id} src={media.filename} onRemove={this.props.onRemove} />
                    })
                }
                {
                    (limit && media.length >= limit)
                        ? null
                        : <AddAttachedImage
                            onClick={() => this.setState({selectDialog: true})}
                        />
                }
            </div>
            <MediaSelectModal
                open={this.state.selectDialog}
                onClose={() => this.setState({selectDialog: false})}
                onChange={this.props.onAdd}
            />
        </>;
    }
}

class Image extends React.Component
{
    static propTypes = {
        id: PropTypes.string.isRequired,
        src: PropTypes.string.isRequired,
        onRemove: PropTypes.func.isRequired,
    };

    render()
    {
        return <div className="group inline-block relative">
            <RemoveImageButton onClick={() => this.props.onRemove(this.props.id)} />
            <div className="w-16 h-16 bg-gray-50 bg-cover" style={{backgroundImage: 'url(' + encodeURI(this.props.src) + ')'}} />
        </div>;
    }
}

const RemoveImageButton = ({onClick}) => {
    return <button onClick={e => {e.preventDefault(); onClick()}} style={{margin: '-10px'}} className={classes.closeButton}>
        <XIcon className='w-4' />
    </button>
};

const AddAttachedImage = ({onClick}) => {
    return <div className="inline-block">
        <button onClick={e => {e.preventDefault(); onClick()}} className="flex items-center justify-center w-16 h-16 bg-gray-50 text-gray-400 hover:text-gray-600">
            <PlusIcon className='w-4 h-4' />
        </button>
    </div>;
}
